// extracted by mini-css-extract-plugin
export default {"section":"src-pages-Order-Components-Discount-css-module__section--ThLH2","discountSelections":"src-pages-Order-Components-Discount-css-module__discountSelections--WqkjZ"};